import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import AuthGate from "./auth/AuthGate";
import DashboardPage from "./pages/DashboardPage";
import GenerateReportPage from "./pages/GenerateReportPage";
import ReportDetailPage from "./pages/ReportDetailPage";

export default function App() {
  return (
    <AuthGate>
      <Layout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/genereer" element={<GenerateReportPage />} />
          <Route path="/rapport/:id" element={<ReportDetailPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </AuthGate>
  );
}
